export default __webpack_public_path__ + "static/media/goodtime.674ba0f0.svg";